import Enumerable from "linq";
import { Header, LightRow } from ".";
import { KeyValuePair } from "..";

export class LightTable {
  constructor(public headers: Header[], public rows: LightRow[]) {
  }

  public clearSelection(): void {
    for (const row of this.rows) {
      row.clearSelection();
    }
  }

  public clearFilter(): void {
    for (const header of this.headers) {
      header.clearFilter();
    }
  }

  public setFilter(filterParameters: KeyValuePair<string, string>[]): void {
    if (!filterParameters) { return; }
    for (const header of this.headers) {
      if (!header.isVisible) { continue; }
      const found = Enumerable.from(filterParameters).firstOrDefault(p => p.key === header.title);
      if (found) {
        header.filterText = found.value;
      }
    }
  }

  public get isSelected(): boolean {
    for (const row of this.rows) {
      if (row.isSelected) { return true; }
    }
    return false;
  }

  public get areCellsSelected(): boolean {
    return this.rows.some(r => r.areCellsSelected);
  }

  public get selectedRows(): LightRow[] {
    const selectedRows: LightRow[] = [];
    for (const row of this.rows) {
      if (!row.isSelected) { continue; }
      selectedRows.push(row);
    }
    return selectedRows;
  }

  public getSelectedValuesByCellIndex(index: number): string[] {
    const values: string[] = [];
    for (const row of this.rows) {
      if (!row.isCellSelected(index)) { continue; }
      const value = row.values[index];
      if (value === undefined) { continue; }
      values.push(value);
    }
    return values;
  }
}
